/** Index of the largest amount; ties go to the first; -1 when none is above zero. */
export function largestAmountIndex(amounts: readonly number[]): number {
  let best = 0;
  let at = -1;
  amounts.forEach((a, i) => {
    if (a > best) {
      best = a;
      at = i;
    }
  });
  return at;
}
